import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSubcontractorProfile } from '@/contexts/SubcontractorProfileContext';

const ProtectedRoute = ({ children, role }) => {
  const { profile, profileLoading, isHydrated } = useSubcontractorProfile();
  const location = useLocation();

  if (profileLoading || !isHydrated) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-900 dark:bg-slate-950">
        <Loader2 className="h-12 w-12 text-blue-500 animate-spin" />
        <p className="text-gray-300 dark:text-gray-400 mt-4">Verifying access...</p>
      </div>
    );
  }

  // Each role has its own sign-in page. A signed-out accountant opening
  // /accountant used to fall through to the CREW login (owner, 2 Nov 2026).
  const loginFor = (r) => (r === 'admin' ? '/admin/login'
    : r === 'partner' ? '/partner-portal/login'
    : r === 'accountant' ? '/accountant/login'
    : '/subcontractor/login');

  if (!profile) {
    return <Navigate to={loginFor(role)} replace state={{ from: location }} />;
  }

  if (profile.role !== role) {
    if (profile.role === 'admin') {
      const isDriverSubdomain = window.location.hostname.includes('drivers.parcelink.org');
      const isAccountingSubdomain = window.location.hostname.includes('accounting.parcelink.org');
      
      let target = '/admin/dashboard';
      if (isDriverSubdomain) target = '/management';
      if (isAccountingSubdomain) target = '/dashboard';
      
      if (location.pathname !== target) {
        return <Navigate to={target} replace />;
      }
    }
    if (profile.role === 'subcontractor') {
      return <Navigate to="/subcontractor/dashboard" replace />;
    }
    if (profile.role === 'accountant') {
      return <Navigate to="/accountant" replace />;
    }
    if (profile.role === 'partner') {
      return <Navigate to="/partner-portal" replace />;
    }

    return <Navigate to={loginFor(role)} replace state={{ from: location }} />;
  }
  
  return children;
};

export default ProtectedRoute;